export default __webpack_public_path__ + "static/media/logo-large.48080470.svg";